import {computed, makeObservable} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import TextField from "../forms/fields/TextField";
import MultipleOptionField from "../forms/fields/MultipleOptionField";
import NumberField from "../forms/fields/NumberField";

export default class LegalEntityForm extends SaporeForm {
    static newEmpty(taxpayerIdentificationNumber, feature = null, configuration) {
        const initialData = {
            taxpayerIdentificationNumber: taxpayerIdentificationNumber,
            businessName: '',
            fantasyName: '',
            fiscalAddress: '',
            city: '',
            postalCode: '',
            jurisdictions: [],
        };
        return new LegalEntityForm(initialData, feature, configuration);
    }

    static newFor(customer, feature = null, configuration) {
        return new LegalEntityForm(customer, feature, configuration);
    }

    constructor(initialData = {}, feature = null, configuration = {}) {
        const form = super({}, null, feature, configuration);

        const fields = {
            taxpayerIdentificationNumber: new TextField(11, 11, this.isOptional('taxpayerIdentificationNumber'), initialData.taxpayerIdentificationNumber, feature),
            businessName: new TextField(1, 100, this.isOptional('businessName'), initialData.businessName, feature),
            fantasyName: new TextField(1, 100, this.isOptional('fantasyName'), initialData.fantasyName, feature),
            fiscalAddress: new TextField(1, 200, this.isOptional('fiscalAddress'), initialData.fiscalAddress, feature),
            city: new TextField(1, 100, this.isOptional('city'), initialData.city, feature),
            postalCode: new NumberField(1, 10, this.isOptional('postalCode'), initialData.postalCode, feature),
            jurisdictions: new MultipleOptionField(feature.jurisdictions(), this.isOptional('jurisdictions'), feature, initialData.jurisdictions || []),
        };

        form.setFields(fields);

        makeObservable(this, {
            taxpayerIdentificationNumberValue: computed,
            businessNameValue: computed,
            fantasyNameValue: computed,
            fiscalAddressValue: computed,
            cityValue: computed,
            postalCodeValue: computed,
            jurisdictionsValue: computed,
        });
    }

    configurationFieldNameMapping() {
        return {
            taxpayerIdentificationNumber: '_taxpayer_identification_number',
            businessName: '_business_name',
            fantasyName: '_fantasy_name',
            fiscalAddress: '_fiscal_address',
            city: '_city',
            postalCode: '_postal_code',
            jurisdictions: '_jurisdictions',
        }
    }

    taxpayerIdentificationNumber() {
        return this.getFieldByName('taxpayerIdentificationNumber').value;
    }

    businessName() {
        return this.getFieldByName('businessName').value;
    }

    fantasyName() {
        return this.getFieldByName('fantasyName').value;
    }

    fiscalAddress() {
        return this.getFieldByName('fiscalAddress').value;
    }

    city() {
        return this.getFieldByName('city').value;
    }

    postalCode() {
        return this.getFieldByName('postalCode').value;
    }

    jurisdictions() {
        return this.getFieldByName('jurisdictions').value;
    }

    get taxpayerIdentificationNumberValue() {
        return this.taxpayerIdentificationNumber();
    }

    get businessNameValue() {
        return this.businessName();
    }

    get fantasyNameValue() {
        return this.fantasyName();
    }

    get fiscalAddressValue() {
        return this.fiscalAddress();
    }

    get cityValue() {
        return this.city();
    }

    get postalCodeValue() {
        return this.postalCode();
    }

    get jurisdictionsValue() {
        return this.jurisdictions();
    }
}
